/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
/**
* Enum class JobIndustry.
* @enum {}
* @readonly
*/
export default class JobIndustry {
    
        /**
         * value: "IT・通信系"
         * @const
         */
        "IT・通信系" = "IT・通信系";

    
        /**
         * value: "サービス系"
         * @const
         */
        "サービス系" = "サービス系";

    
        /**
         * value: "メーカー系(電気・機械)"
         * @const
         */
        "メーカー系(電気・機械)" = "メーカー系(電気・機械)";

    
        /**
         * value: "メーカー系(素材・医薬品他)"
         * @const
         */
        "メーカー系(素材・医薬品他)" = "メーカー系(素材・医薬品他)";

    
        /**
         * value: "メーカー系(自動車・輸送用機器)"
         * @const
         */
        "メーカー系(自動車・輸送用機器)" = "メーカー系(自動車・輸送用機器)";

    
        /**
         * value: "専門コンサル系"
         * @const
         */
        "専門コンサル系" = "専門コンサル系";

    
        /**
         * value: "商社系(電気・機械系)"
         * @const
         */
        "商社系(電気・機械系)" = "商社系(電気・機械系)";

    
        /**
         * value: "商社系(総合・素材・医薬品他)"
         * @const
         */
        "商社系(総合・素材・医薬品他)" = "商社系(総合・素材・医薬品他)";

    
        /**
         * value: "金融系"
         * @const
         */
        "金融系" = "金融系";

    
        /**
         * value: "不動産系"
         * @const
         */
        "不動産系" = "不動産系";

    
        /**
         * value: "建設系"
         * @const
         */
        "建設系" = "建設系";

    
        /**
         * value: "マスコミ系"
         * @const
         */
        "マスコミ系" = "マスコミ系";

    
        /**
         * value: "流通・小売系"
         * @const
         */
        "流通・小売系" = "流通・小売系";

    
        /**
         * value: "インターネット・Web業界"
         * @const
         */
        "インターネット・Web業界" = "インターネット・Web業界";

    
        /**
         * value: "ゲーム業界"
         * @const
         */
        "ゲーム業界" = "ゲーム業界";

    
        /**
         * value: "広告・マーケティング系"
         * @const
         */
        "広告・マーケティング系" = "広告・マーケティング系";

    
        /**
         * value: "教育・学校系"
         * @const
         */
        "教育・学校系" = "教育・学校系";

    
        /**
         * value: "医療・福祉系"
         * @const
         */
        "医療・福祉系" = "医療・福祉系";

    
        /**
         * value: "エネルギー・環境系"
         * @const
         */
        "エネルギー・環境系" = "エネルギー・環境系";

    
        /**
         * value: "官公庁・公共サービス系"
         * @const
         */
        "官公庁・公共サービス系" = "官公庁・公共サービス系";

    
        /**
         * value: "運輸・物流・倉庫系"
         * @const
         */
        "運輸・物流・倉庫系" = "運輸・物流・倉庫系";

    
        /**
         * value: "飲食・フード系"
         * @const
         */
        "飲食・フード系" = "飲食・フード系";

    
        /**
         * value: "その他"
         * @const
         */
        "その他" = "その他";

    

    /**
    * Returns a <code>JobIndustry</code> enum value from a Javascript object name.
    * @param {Object} data The plain JavaScript object containing the name of the enum value.
    * @return {module:model/JobIndustry} The enum <code>JobIndustry</code> value.
    */
    static constructFromObject(object) {
        return object;
    }
}

